// Vendors
import $ from 'jquery';

// This should only run once..
$('.has-mega-menu--alt').one('mouseover', event => {
  // initate hover state for first menu item, and show children menu items.
  $(event.currentTarget)
    .find('ul.sub-menu li.menu-item-has-children')
    .first()
    .addClass('menu-item--active')
    .trigger('mouseover');
});

// Make hover states 'sticky', and resize mega menu height if needed to fit content.
$('.nav-primary .has-mega-menu--alt ul.sub-menu li.menu-item-has-children').on(
  'mouseover',
  event => {
    const $this = $(event.currentTarget);
    const $menuWrapper = $this
      .closest('li.has-mega-menu--alt')
      .children('ul.sub-menu');

    // reset active states
    $('.menu-item--active').removeClass('menu-item--active');

    // toggle stuff
    $this.addClass('menu-item--active');
    $this.find('.sub-menu').show();

    // // change wrapper height dynamically.
    // // (submenu has position: absolute; so it can't "stretch" the height of its parent container)
    // let newHeight =
    //   80 +
    //   parseInt(
    //     $this
    //       .find('ul.sub-menu > li.mega-menu-header > ul.sub-menu')
    //       .outerHeight()
    //   );
    // newHeight = newHeight < 210 ? 210 : newHeight;
    // $menuWrapper.height(newHeight + 'px');
  }
);
